exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".coluna-direita .collapsible-body [type=checkbox].filled-in-box+label[data-v-2b2e9c18]:before{border:2px solid var(--primary-color)!important}.coluna-direita .collapsible-body [type=checkbox].filled-in-box:checked+label[data-v-2b2e9c18]:before{border:unset!important;border-right:2px solid var(--primary-color)!important;border-bottom:2px solid var(--primary-color)!important}.highlighted-search mark[data-v-2b2e9c18]{background-color:#ff0;font-weight:700;padding:0 2px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-2b2e9c18","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/shared/CatalogoLogin/CatalogoLogin.vue
// module id = 308
// module chunks = 135